import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getLearningTopicCopy, getLearningTopicText, rtlLearningLanguages } from "@/components/public/learningTopicTranslations";

export default function LearningTopicsSection({ topics, topicDetails = {}, prefix, articleCounts = {}, lang = "en" }) {
  const copy = getLearningTopicCopy(lang).section;
  const isRtl = rtlLearningLanguages.has(lang);
  const title = lang === "en" ? `Choose one of ${topics.length} maritime learning topics` : copy.title;

  return (
    <section className="mt-8 pb-8" dir={isRtl ? "rtl" : "ltr"}>
      <div className="mb-6 max-w-4xl">
        <p className="text-xs font-black uppercase tracking-[0.34em] text-[#168F92] md:text-sm">{copy.eyebrow}</p>
        <h2 className="mt-2 font-heading text-[2rem] font-black leading-[1.05] tracking-[-0.04em] text-[#081633] md:text-[2.8rem]">{title}</h2>
      </div>
      <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
        {topics.map((topic, index) => {
          const detail = topicDetails[topic.slug] || {};
          const translated = getLearningTopicText(topic.slug, lang, topic);
          const articleCount = articleCounts[topic.slug] || 0;
          const articleCountLabel = `${articleCount} ${articleCount === 1 ? "article" : "articles"}`;
          return (
            <React.Fragment key={topic.slug}>
              <Link to={`${prefix}/learning-center/${topic.slug}`} className="group overflow-hidden rounded-[1.35rem] border border-[#BFDADC] bg-white/92 shadow-[0_14px_35px_rgba(8,22,51,0.08)] transition hover:-translate-y-1 hover:border-[#17A6A4] hover:shadow-[0_24px_50px_rgba(8,22,51,0.14)]">
                <div className="relative h-32 overflow-hidden bg-[#D9EFF0]">
                  <img src={detail.image} alt={copy.imageAlt(translated.title)} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#081633]/55 via-transparent to-transparent" />
                  <div className="absolute left-4 top-4 flex flex-wrap gap-2">
                    <span className="rounded-full bg-white px-3 py-1 text-[0.68rem] font-black text-[#081633] shadow-sm">{copy.topic} {index + 1}</span>
                    <span className="rounded-full bg-[#168F92] px-3 py-1 text-[0.68rem] font-black text-white shadow-sm">{articleCountLabel}</span>
                  </div>
                </div>
                <div className="relative min-h-[8.7rem] overflow-hidden p-4">
                  <div className="absolute -bottom-8 -right-8 h-28 w-28 rounded-full border border-[#17A6A4]/10 bg-[#17A6A4]/5" />
                  <h3 className="relative text-lg font-black leading-tight text-[#081633]">{translated.title}</h3>
                  <p className="relative mt-2 line-clamp-2 text-xs font-bold leading-5 text-[#10233E]">{translated.description}</p>
                  <span className="relative mt-3 inline-flex items-center gap-2 text-xs font-black text-[#168F92]">{copy.viewArticles} <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" /></span>
                </div>
              </Link>
            </React.Fragment>
          );
        })}
      </div>
    </section>
  );
}